







































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {AuthStore} from "@/modules/auth/store";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import CardStatistic from "@/modules/dashboard/components/CardStatistic.vue";
import MillisecondMonthPicker from "@/shared/components/MillisecondMonthPicker/index.vue";
import {DashboardParams} from "@/modules/dashboard/params";
import {statisticBillLading, statisticCod, statisticFee} from "@/modules/dashboard/service";
import moment from 'moment';
import 'moment/locale/vi';
import {LadingCustomerStatus} from "@/enums/status/ladingcustomerstatus";
import LadingErrorCustomerList from "@/modules/ladingerrorcustomer/List/index.vue";

@Component({
    name: "Dashboard",
    components: {LadingErrorCustomerList, MillisecondMonthPicker, CardStatistic, MillisecondDatePicker}
})
export default class extends mixins(CommonMixin) {
    params = new DashboardParams();

    totalBill = 0;
    dashboardBillLadings = [] as any;
    dashboardCod = [] as any;
    dashboardFee = [] as any;

    get customer() {
        return AuthStore.user?.customer;
    }

    get monthSelected() {
        return moment(this.params.fromDate).month() + 1;
    }

    created() {
        this.getDashboardBillLading(this.params);
        this.getDashboardCod(this.params);
        this.getDashboardFee(this.params);
    }

    @Watch('params', {deep: true})
    onchangeParams(val: any) {
        const toDate = moment(val?.fromDate).endOf('month').valueOf();
        this.getDashboardBillLading({...this.params, toDate});
        this.getDashboardCod({...this.params, toDate});
        this.getDashboardFee({...this.params, toDate});
    }

    async getDashboardBillLading(params: any) {
        try {
            const {data} = await statisticBillLading(params);
            this.dashboardBillLadings = data.data.dashBoard.filter(item => item.status !== LadingCustomerStatus.Reject);
            this.totalBill = data.data.info.totalBillLading;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    async getDashboardCod(params: any) {
        try {
            const {data} = await statisticCod(params);
            this.dashboardCod = data.datas;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    async getDashboardFee(params: any) {
        try {
            const {data} = await statisticFee(params);
            this.dashboardFee = data.datas;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    redirectToLadings(data: any) {
        this.$router.push(
            {
                name: 'listLading',
                query: {
                    statusCustomer: data.status,
                    statusString: data.statusString,
                    fromDate: this.params.fromDate,
                    toDate: this.params.toDate
                } as any
            })
    }

    getIconLading(data: any) {
        let icon = "";
        switch (data.status) {
            case LadingCustomerStatus.ChoLayHang:
                icon = "icon-cho-lay.png";
                break;
            case LadingCustomerStatus.LayHangThanhCong:
                icon = "icon-lay-hang.png";
                break;
            case LadingCustomerStatus.DiPhat:
                icon = 'icon-di-phat.png';
                break;
            case LadingCustomerStatus.PhatThanhCong:
                icon = 'icon-phat-thanh-cong.png';
                break;
            case LadingCustomerStatus.PhatKhongThanhCong:
                icon = 'icon-su-co.png';
                break;
            case LadingCustomerStatus.DuyetHoan:
                icon = 'icon-chuyen-hoan.png';
                break;
            case LadingCustomerStatus.DangHoan:
                icon = 'icon-dang-hoan.png';
                break;
            case LadingCustomerStatus.HoanThanhCong:
                icon = 'icon-phat-thanh-cong.png';
                break;
            case LadingCustomerStatus.Reject:
                icon = 'icon-huy-don.png';
                break;
            default:
                icon = 'icon-lay-hang.png';
                break;
        }

        return icon;
    }
}
